import 'daterangepicker/daterangepicker';
import $ from 'jquery';

document.addEventListener('DOMContentLoaded', () => {
  const $dateRangeSelector = $('.table-widget__date-to-string');
  const $sevenRoomsForm = $('.js-table-form-seven-rooms-widget');
  const fieldDate = document.querySelector('.table-widget__field--date');

  $dateRangeSelector.each(function () {
    const picker = $(this).daterangepicker({
      singleDatePicker: true,
      startDate: new Date(),
      minDate: new Date(),
      opens: 'center',
      // eslint-disable-next-line no-undef
      locale: daterangeLocale,
      cancelButtonClasses: 'cancelBtn c-button c-button--blue c-loop-focus__close',
      applyButtonClasses: 'applyBtn c-button c-button--blue',
    }, (start) => {
      const format = `YYYY-MM-DD${fieldDate.dataset.appendDate}`;
      // eslint-disable-next-line no-undef
      $dateRangeSelector.text(`${daterangeLocale.monthNames[start.format('M') - 1]} ${start.format('D')}`);
      fieldDate.value = start.format(format);
    }).data('daterangepicker');

    picker.container.addClass('c-daterangepicker c-loop-focus');

    $dateRangeSelector.off('focus.daterangepicker');
    $(this).on('show.daterangepicker', () => {
      $('.daterangepicker td.active:not(.off)').focus();
    });

    $(this).on('showCalendar.daterangepicker', () => {
      $('.daterangepicker th.available:not(.off), .daterangepicker td.available:not(.disabled)').attr('tabindex', 0);
    });

    $(this).on('hide.daterangepicker', () => {
      $(this).focus();
    });
  });

  if ($sevenRoomsForm.length) {
    const $sevenRoomsSelect = $sevenRoomsForm.find('.js-table-widget-restaurant-select');

    if ($sevenRoomsSelect) {
      $sevenRoomsSelect.on('change', function () {
        const url = $(this).find(':selected').data('url');

        if (url) {
          $sevenRoomsForm.attr('action', url);
        }
      });
    }
  }
});
